import { useState, useLayoutEffect } from "react"
import { useLocation, useNavigate, useLoaderData, useOutletContext } from "react-router-dom"
import { useAuth } from "contexts/auth-context"
import Form from "./form"
import nProgress from "nprogress"
import toast from "react-hot-toast"
import { useSWRConfig } from "swr"
import { usePage } from "contexts/page-context"
import { Transition } from "components"
import { lang } from "config"
import { executeAPI } from "repositories/db-repository"

export default function Create() {
  const { user } = useAuth()
  const { cache } = useSWRConfig()

  const { setTransition } = usePage()
  const { setTitle } = useOutletContext()

  // data awal dari loader (mis. daftar PO, dsb, kalau ada)
  const data = useLoaderData()

  const location = useLocation()
  const navigate = useNavigate()

  const [errors, setErrors] = useState({})

  useLayoutEffect(() => {
    setTransition(location.state?.transition)
    setTitle(`Create Return`)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleSubmit = (payload) => {
    const onSuccess = (result, message) => {
      nProgress.done()
      cache.clear()
      if(payload.latest_flow_detail_id === "RETURN_COMPLETE"){

      }
      navigate({ pathname: "/return" })
      toast.success("Return berhasil disimpan!", { id: "submit" })
    }

    const onError = (message) => {
      nProgress.done()
      toast.error("onError: " + message, { id: "submit" })
    }

    // validasi ringan header
    if (payload.warehouse_name && payload.supplier_name && payload.warehouse_address) {
      nProgress.start()
      toast.loading("Loading", { id: "submit" })
      console.log(payload)
      // Insert header retur
      executeAPI(
        `${process.env.REACT_APP_REMAX_PS_API_URL}`,
        "insert_return_header",
        {
          // header minimal
          origin: payload?.origin ?? "RT",
          outlet_group_id: payload?.outlet_group_id,
          outlet_group_name: payload?.outlet_group_name,
          outlet_group_phone_number: payload?.outlet_group_phone_number,
          user_id: payload?.user_id,
          user_name: payload?.user_name,
          outlet_id: payload?.outlet_id,
          outlet_name: payload?.outlet_name,
          outlet_phone_number: payload?.outlet_phone_number,
          outlet_email_address: payload?.outlet_email_address,
          entry_date: payload?.entry_date,

          // BY_PO optional
          purchase_header_id: payload?.return_type === "BY_PO" ? payload?.purchase_header_id : null,
          purchase_transaction_id: payload?.return_type === "BY_PO" ? payload?.purchase_transaction_id : null,

          // ship & supplier
          warehouse_id: payload?.warehouse_id,
          warehouse_name: payload?.warehouse_name,
          warehouse_address: payload?.warehouse_address,

          supplier_id: payload?.supplier_id,
          supplier_name: payload?.supplier_name,
          supplier_phone_number: payload?.supplier_phone_number,
          supplier_email_address: payload?.supplier_email_address,
          supplier_address: payload?.supplier_address,

          notes: payload?.notes,
          ppn_percentage: payload?.ppn_percentage ?? 11,

          return_type: payload?.return_type ?? "BY_PRODUCT",

          // status awal
          latest_flow_detail_id: payload.latest_flow_detail_id,
          flow_detail_id: payload.flow_detail_id,

          record_status: "I",
          created_by: user?.name
        },
        onSuccess,
        onError
      )
    } else {
      setErrors({
        outlet_name: payload.outlet_name ? undefined : lang.outlet_name + " " + lang.field_required,
        warehouse_name: payload.warehouse_name ? undefined : lang.deliver_to + " " + lang.field_required,
        supplier_name: payload.supplier_name ? undefined : lang.supplier_name + " " + lang.field_required,
        warehouse_address: payload.warehouse_address ? undefined : lang.delivery_address + " " + lang.field_required
      })
    }
  }

  return (
    <Transition type="fade">
      <Form data={data} errors={errors} onSubmit={handleSubmit} />
    </Transition>
  )
}
